export default "__VITE_ASSET__CuSseQbE__"